import React, { Component } from 'react'
import {FormattedMessage, injectIntl} from 'react-intl'
import SectionEditForm from './section.component.jsx'
const uuidv4 = require('uuid/v4')

class SectionsEditForm extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            sections: this.props.sections || [],
        }

        const defaultCallback = () => {}
        this.modelId = this.props.modelId || ''
        this.nextOrder = this.state.sections.length.toString()
        this.onChange = this.props.onChange || defaultCallback
        this.createNewSection = this.createNewSection.bind(this)
        this.onSectionChange = this.onSectionChange.bind(this)
        this.onSectionDelete = this.onSectionDelete.bind(this)
    }

    componentDidMount() {}

    createNewSection(event) {
        event.preventDefault()
        const sections = this.state.sections
        sections.push({
            id: uuidv4(),
            attributes: {
                name: '',
                order: this.nextOrder,
                modelId: this.modelId,
                labelIds: [],
                subSections: [],
            },
        })
        this.nextOrder = this.state.sections.length.toString()
        this.setState({
            sections: sections
        }, () => this.onChange(this.state.sections))
    }

    onSectionChange(section) {
        this.setState({
            sections: this.state.sections.map(s => {
                if (s.id === section.id) {
                    return section
                } else {
                    return s
                }
            })
        }, () => this.onChange(this.state.sections))
    }

    onSectionDelete(section) {
        this.setState({
            sections: this.state.sections.filter(s => s.id !== section.id)
        }, () => this.onChange(this.state.sections))
    }

    render() {
        return (
            <div className="col-12 ui-module">
                <h5>
                    <FormattedMessage
                        id="guided_selling.form.edit.sections.title"
                        defaultMessage="Sections"
                    />
                </h5>
                {this.state.sections.map(
                    section => <SectionEditForm
                        key={section.id}
                        onChange={this.onSectionChange}
                        onDelete={this.onSectionDelete}
                        section={section}
                    />
                )}
                <div className="row">
                    <div className="col-8">
                        <button className="btn btn-primary btn-sm" onClick={this.createNewSection}>
                            <FormattedMessage
                                id="guided_selling.form.edit.add_section_btn"
                                defaultMessage="Add a new section"
                            />
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default injectIntl(SectionsEditForm)


// WEBPACK FOOTER //
// ./src/guided-selling/form/sections.component.jsx